import { PropsWithChildren } from "react";
import { Stack } from "@mui/material";

interface Props extends PropsWithChildren<{}> {}
export default function PageHeader({ children }: Props) {
  return <Stack direction="row">{children}</Stack>;
}
